import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowDown } from 'lucide-react';
import MicroLabel from '../components/MicroLabel';
import { euro, pct } from '../format';

/**
 * Chapter 01 — Hero.
 *
 * The headline, today's net worth, and the all-time return beside it. The only
 * chapter that carries the secondary "Open the detailed view" action in its
 * header row.
 */
function Hero({ story }) {
  const gain = story?.totalGainPct;
  const rising = Number.isFinite(gain) && gain >= 0;

  return (
    <>
      <div className="story-hero-body">
        <h1 className="story-h1">
          Your money,
          <br />
          in nine short chapters.
        </h1>

        <div className="story-hero-networth">
          <div>
            <MicroLabel>Net worth today</MicroLabel>
            <div
              className="story-figure story-hero-figure"
              style={{ marginTop: 8 }}
              data-testid="story-net-worth"
            >
              {euro(story?.netWorth)}
            </div>
          </div>
          <span className="story-tag story-tag-accent">
            {rising ? '▲' : '▼'} {pct(gain)} all time
          </span>
        </div>
      </div>

      <MicroLabel className="story-scroll-cue">
        <ArrowDown size={14} aria-hidden="true" />
        Scroll — the story starts here
      </MicroLabel>
    </>
  );
}

/**
 * The header action for chapter 01, rendered by the page so `Chapter` keeps its
 * generic shape.
 */
export function HeroAction() {
  return (
    <Link className="story-btn story-btn-secondary" to="/">
      Open the detailed view
      <ArrowRight size={16} className="story-btn-icon" aria-hidden="true" />
    </Link>
  );
}

export default Hero;
